import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogTitle, DialogFooter } from "src/components/ui/dialog";
import Col from "react-bootstrap/esm/Col";
import { Button } from "src/components/ui/button";
import Divider from "src/components/ui/divider";
import BookCall from "src/components/book-call";
import Text from "src/components/ui/text";
import { useScoutPackage } from "src/hooks/dashboard";
import { useCreatePackageOrderRequest } from "src/hooks/api/membership";
import { useNavigate } from "react-router-dom";

interface IStandardTier {
  isModalShow: boolean;
  closeModal: () => void;
}

export const StandardTier = ({ isModalShow, closeModal }: IStandardTier) => {
  const { t } = useTranslation();
  const { data: scoutPackage, isLoading: isScoutPackageLoading } = useScoutPackage();
  const { data: orderData, mutate, status } = useCreatePackageOrderRequest();
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (!scoutPackage?.id) return;

    mutate({
      id: scoutPackage.id,
      is_installment: false,
    });
  };

  React.useEffect(() => {
    if (status === "success" && orderData?.data) {
      if (orderData.data.package.area_level === 0) {
        navigate(`/order/checkout/${orderData.data.id}/payment-information/`);
      } else {
        navigate(`/order/checkout/${orderData.data.id}/location/`);
      }
    }
  }, [status, orderData]);

  return (
    <Dialog open={isModalShow} onOpenChange={closeModal}>
      <DialogContent className="p-4 md:p-6 overflow-y-auto overflow-x-hidden flex max-h-screen max-w-full flex-col md:min-w-[400px] md:max-w-[450px] w-full min-h-screen md:min-h-fit">
        <DialogTitle>{`Oops! This feature is only available with the ${scoutPackage?.name} tier Subscription.`}</DialogTitle>
        <DialogDescription className="sr-only" />
        <div className="flex-1 mb-1">
          <Col xs={{ span: 22, offset: 1 }}>
            <Text fontSize="7" alignment="start" style={{ marginBottom: 16 }}>
              {`Subscribe to ${scoutPackage?.name} tier to access all of our features & Scout Ai:`}
            </Text>
            <ul className="av-list av-list--small">
              <li className="av-list__item">{t("Explore short-term rental regulation in 1,000+ cities")}</li>
              <li className="av-list__item">{t("Analyze any property for Arbitrage/purchase potential")}</li>
              <li className="av-list__item">{t("in-depth information on ordinaces, permiting and location analysis.")}</li>
              <li className="av-list__item">{t("Set alerts on Regulations changes")}</li>
              <li className="av-list__item">{t("Find the most profitable locations")}</li>
              <li className="av-list__item">{t("Monitor markets")}</li>
            </ul>
          </Col>
        </div>
        <DialogFooter className="flex !flex-col pb-0">
          <Button className="w-100" disabled={isScoutPackageLoading} onClick={handleUpgrade}>
            {isScoutPackageLoading ? t("Loading...") : t("Upgrade tier")}
          </Button>
          <Divider className="w-100" text={t("or") as string} />
          <BookCall
            className="w-100 !text-foreground"
            buttonVariant="outline"
            buttonText={isScoutPackageLoading ? t("Loading...") : t("Request Demo")}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
